/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

//table columns for pending table section 
export const columns: TableColumn[] = [
    {
      Header: 'EnvironmentalFlora.tableColumns.slNo',
      accessor: 'sl_no',
    },
    {
      Header: 'scheduleOperator.tableColumns.production_schedule',
      accessor: 'schedule_production',
    },
    {
      Header: 'scheduleOperator.tableColumns.product_name',
      accessor: 'product_name',
    },
    {
      Header: 'EnvironmentalFlora.tableColumns.serialNo',
      accessor: 'serial_number',
    },
    {
      Header: 'tableCommon.batch_code',
      accessor: 'batch_number',
    },
    {
      Header: 'EnvironmentalFlora.tableColumns.activityType',
      accessor: 'activity_type',
    },
  ];

  //table columns for history table section 
  export const HistoryColumns: TableColumn[] = [
    {
      Header: 'EnvironmentalFlora.tableColumns.slNo',
      accessor: 'slno',
    },
    {
      Header: 'scheduleOperator.tableColumns.production_schedule',
      accessor: 'schedule_production',
    },
    {
      Header: 'scheduleOperator.tableColumns.product_name',
      accessor: 'product_name',
    },
    {
      Header: 'EnvironmentalFlora.tableColumns.serialNo',
      accessor: 'serial_number',
    },
    {
      Header: 'tableCommon.batch_code',
      accessor: 'batch_number',
    },
    {
       Header: 'EnvironmentalFlora.tableColumns.updatedAt',
       accessor: 'updated_at',
    },
  ];
  
  interface TableColumn {
    Header: string;
    accessor: string;
  }
  